module.exports = __webpack_public_path__ + "img/chart-active.30a7828a.svg";